// React libs
import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
// Services
import CommonService from '../Services/CommonService';
// Types
import * as CoreTypes from '../Models/Core.type';
// Common
import CoreCommon from '../../Resources/Common';

export interface IGetThematicHook extends CoreTypes.IHook<CoreTypes.IThematic[]> { }

const useThematic = (): IGetThematicHook => {
  // Variables
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  // State
  const [data, setData] = useState<CoreTypes.IThematic[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    setIsLoading(true)
    CommonService.getThematic()
      .then((data: CoreTypes.IData<CoreTypes.IThematic>) => {
        setData(data.data)
        setIsLoading(false)
      })
      .catch((e: CoreTypes.IWsException) => {
        enqueueSnackbar(
          e?.error?.message || t('common:errors.defaultMessage'),
          {
            ...CoreCommon.Constantes.snackbarDefaultProps,
            variant: 'error',
          }
        );
        setIsLoading(false);
      });
  }, [enqueueSnackbar, t])

  return { data, isLoading }
}

export default useThematic